import dateFormat from 'dateformat'

const reports = (state = [], action) => {
  switch (action.type) {
    case 'LOAD_REPORTS': 
      return action.snapshot.docs.map(doc => {
        let report = doc.data()
        report.date = dateFormat(report.date.toDate(), "yyyy/mm/dd")
        report.created = report.created? dateFormat(report.created.toDate(), "yyyy/mm/dd HH:MM") : ""
        report.id = doc.id
        return report
      })
    default: 
      return state
  }
}
export default reports


// WEBPACK FOOTER //
// ./src/reducers/reports.js